import { Box, CircularProgress } from '@mui/material';
import { Dispatch, ReactElement, useEffect, useState } from 'react';
// import { AuthenticationService } from 'services/AuthenticationService';
import { ConfirmDialog } from 'shared/components/AppComponents';

// interface IDomainConfig {
//   domain: string[];
//   redirectUrl: string;
// }
export const useEmailValidation = (): {
  fetchingEmailConfig: boolean;
  setFetchingEmailConfig: Dispatch<React.SetStateAction<boolean>>;
  redirectUrl: string;
  setRedirectUrl: Dispatch<React.SetStateAction<string>>;
  validateEmail: (email: string) => string;
  validationBackendError: (error: any) => void;
} => {
  const [fetchingEmailConfig, setFetchingEmailConfig] = useState(false);
  //   const [domainConfig, setDomainConfig] = useState<IDomainConfig[]>([
  //     {
  //       domain: [],
  //       redirectUrl: '',
  //     },
  //   ]);
  const [redirectUrl, setRedirectUrl] = useState('');
  //   const fetchEmailConfig = (): void => {
  //     setFetchingEmailConfig(true);
  //     AuthenticationService.fetchEmailConfig()
  //       .then((response) => {
  //         const { data } = response.data;
  //         setDomainConfig(data);
  //         console.log(response);
  //       })
  //       .catch((error) => {
  //         console.log(error);
  //       })
  //       .finally(() => setFetchingEmailConfig(false));
  //   };

  const validateEmail = (email: string): string => {
    const domain = email.split('@').pop();
    if (domain) {
      //   const config = domainConfig.find((d) => d.domain.includes(domain));
      //   if (config) {
      //     const url = config.redirectUrl;
      //     setRedirectUrl(url);
      //     return url;
      //   }
      setRedirectUrl('');
    }
    setRedirectUrl('');
    return '';
  };

  const validationBackendError = (error: any): void => {
    const { response } = error;
    const { data } = response;
    if (data.data && data.data?.redirectUrl) {
      setRedirectUrl(data.data?.redirectUrl);
    }
  };

  useEffect(() => {
    // fetchEmailConfig();
  }, []);

  return {
    fetchingEmailConfig,
    setFetchingEmailConfig,
    redirectUrl,
    setRedirectUrl,
    validateEmail,
    validationBackendError,
  };
};

const EmailValidation = (props: {
  showLoading: boolean;
  redirectURL: string;
  email: string;
  onClose: () => void;
}): ReactElement => {
  const { showLoading, redirectURL, email, onClose } = props;
  return (
    <>
      {showLoading && (
        <Box className="empty-content">
          <CircularProgress />
        </Box>
      )}
      <ConfirmDialog
        title="Restriction"
        subTitle={`Access to this email ${email} is redirecting you to ${redirectURL}. Do you wants to continue ?`}
        showConfirm={!!redirectURL}
        cancelTitle="Cancel"
        successTitle="Click here to redirect"
        onSuccess={() => {
          window.open(redirectURL, email);
          onClose();
        }}
        onCancel={onClose}
      />
    </>
  );
};

export default EmailValidation;
